import type { SVGProps } from "react";

/**
 * arrow-inbox, download, file, down, save
 * @category Interface General
 */
export default function IconArrowInbox(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M20.25 14.75V18.25C20.25 19.3546 19.3546 20.25 18.25 20.25H5.75C4.64543 20.25 3.75 19.3546 3.75 18.25V14.75M12 15V3.75M12 15L8.5 11.5M12 15L15.5 11.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
